"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.take = take;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Subscriber2 = require("../Subscriber");

var _ArgumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");

var _EmptyObservable = require("../observable/EmptyObservable");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
  return function (source) {
    if (count === 0) {
      return new _EmptyObservable.EmptyObservable();
    } else {
      return source.lift(new TakeOperator(count));
    }
  };
}

var TakeOperator =
/*#__PURE__*/
function () {
  function TakeOperator(total) {
    (0, _classCallCheck2.default)(this, TakeOperator);
    this.total = total;

    if (this.total < 0) {
      throw new _ArgumentOutOfRangeError.ArgumentOutOfRangeError();
    }
  }

  (0, _createClass2.default)(TakeOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new TakeSubscriber(subscriber, this.total));
    }
  }]);
  return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var TakeSubscriber =
/*#__PURE__*/
function (_Subscriber) {
  (0, _inherits2.default)(TakeSubscriber, _Subscriber);

  function TakeSubscriber(destination, total) {
    var _this;

    (0, _classCallCheck2.default)(this, TakeSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TakeSubscriber).call(this, destination));
    _this.total = total;
    _this.count = 0;
    return _this;
  }

  (0, _createClass2.default)(TakeSubscriber, [{
    key: "_next",
    value: function _next(value) {
      var total = this.total;
      var count = ++this.count;

      if (count <= total) {
        this.destination.next(value);

        if (count === total) {
          this.destination.complete();
          this.unsubscribe();
        }
      }
    }
  }]);
  return TakeSubscriber;
}(_Subscriber2.Subscriber);